export const getInitials = (fullName: string, maxInitials: number = 2): string =>
  fullName
    .split(/\s/)
    .map((part) => part.substring(0, 1).toUpperCase())
    .filter((part) => !!part)
    .slice(0, maxInitials)
    .join('');

// Pool of accent variants used to auto-pick a color by name - `primary` is
// intentionally excluded, it's reserved for an explicit/deliberate choice.
const ACCENT_VARIANTS = [
  'accent-01',
  'accent-02',
  'accent-03',
  'accent-04',
  'accent-05',
  'accent-06',
  'accent-07',
  'accent-08',
  'accent-09',
  'accent-10',
  'accent-11',
  'accent-12',
  'accent-13',
  'accent-14',
  'accent-15',
  'accent-16',
  'accent-17',
] as const;

// Deterministic pseudo-random pick (Linear Congruential Generator seeded from the
// name's char codes), so the same fullName always resolves to the same color.
// https://en.wikipedia.org/wiki/Linear_congruential_generator
function stringAsciiPRNG(value: string, m: number): number {
  const charCodes = [...value].map((letter) => letter.charCodeAt(0));
  const len = charCodes.length;

  const a = (len % (m - 1)) + 1;
  const c = charCodes.reduce((current, next) => current + next) % m;

  let random = charCodes[0] % m;

  for (let i = 0; i < len; i++) {
    random = (a * random + c) % m;
  }

  return random;
}

export function getAvatarVariant(fullName: string): (typeof ACCENT_VARIANTS)[number] {
  if (!fullName) {
    return 'accent-01';
  }

  const colorIndex = stringAsciiPRNG(fullName, ACCENT_VARIANTS.length);

  return ACCENT_VARIANTS[colorIndex];
}
